<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pb-0">
        <setorizacoes-navigation-tabs :selectedTab.sync="selectedTabNavegationTabs" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <setorizacoes-data-table
          ref="setorizacoesDataTable"
          :titulo="tituloTabela"
          :items="items"
          :loading="loading"
          @rechargeTable="chargeTableDecision(tipoListaSetorizacao)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SetorizacoesService from '@/services/SetorizacoesService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      SetorizacoesNavigationTabs: () => import('@/components/setorizacoes/SetorizacoesNavigationTabs'),
      SetorizacoesDataTable: () => import('@/components/setorizacoes/SetorizacoesDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      tituloTabela: 'Setorizações',
      selectedTabNavegationTabs: 0,
      loading: false
    }),

    computed: {
      tipoListaSetorizacao() {
        return this.$store.getters.getTipoListaSetorizacao;
      }
    },

    created() {
      this.chargeTableDecision(this.tipoListaSetorizacao);
    },

    methods: {
      getSetorizacoes() {
        this.items = [];
        this.loading = true;
        SetorizacoesService.index()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      getSetorizacoesFavoritadas() {
        this.items = [];
        this.loading = true;
        SetorizacoesService.getSetorizacoesFavoritadas()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      chargeTableDecision(newDecisionInfo) {
        if (this.$refs.setorizacoesDataTable) {
          this.$refs.setorizacoesDataTable.page = 1;
        }
        this.tituloTabela = newDecisionInfo.titulo;

        switch (newDecisionInfo.tipo) {
          case 'favoritos':
            this.selectedTabNavegationTabs = 1;
            this.cancelRefreshData();
            this.refreshData(this.getSetorizacoesFavoritadas);
            break;
          case 'historico':
          default:
            this.selectedTabNavegationTabs = 0;
            this.cancelRefreshData();
            this.refreshData(this.getSetorizacoes);
            break;
        }
      }
    },

    watch: {
      tipoListaSetorizacao(newValue) {
        this.chargeTableDecision(newValue);
      }
    }
  };
</script>
